import { memoizeWith } from 'ramda';

import { TBlock } from 'detailsv2/__blocks';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';

import { usePageContext } from '../../context';
import Block from '../Block';
import s from '../index.module.css';

const BlocksContent = () => {
  const { data, readonly, config: pageConfig } = usePageContext();
  const { blockHandlersProvider: BlockHandlersProvider } = useLandingV2Context();

  return (
    <div className={s.blocksContent}>
      {data.blocks.map((block, index) => {
        // TODO remove
        const readyBlocks = [
          'header',
          'text',
          'image',
          'safari_map',
          'safari_costs',
          'cover_page',
          'safari_overview',
          'safari_manifest',
          'embed',
          'iframe',
          'list',
          'trip_event',
          'document',
          'accordion',
          'travel_wallet',
          'guest_forms',
          'subtitle',
        ];
        if (block._destroy || !readyBlocks.includes(block.type)) return null;

        return (
          <BlockHandlersProvider key={block.id || block.originalId || index} index={withIndex(index)}>
            {({
              onAdd,
              onUpdate,
              onDelete,
              onAddBlockInsideSpoiler,
              onUpdateBlockInsideSpoiler,
              onDeleteBlockInsideSpoiler,
            }) => (
              <Block
                readonly={readonly}
                disabledAddingBlocks={pageConfig.disabledAddingBlocks}
                block={block as TBlock}
                index={withIndex(index)}
                onAdd={onAdd}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onAddBlockInsideSpoiler={onAddBlockInsideSpoiler}
                onUpdateBlockInsideSpoiler={onUpdateBlockInsideSpoiler}
                onDeleteBlockInsideSpoiler={onDeleteBlockInsideSpoiler}
              />
            )}
          </BlockHandlersProvider>
        );
      })}
    </div>
  );
};

export default BlocksContent;

const withIndex = memoizeWith(
  (i) => String(i),
  (i) => {
    return [i];
  },
);
